<template>
  <div class="queue-box">
    <div class="infos">
      <div class="title">
        {{ $t("客服繁忙，让您久等了") }}👉
        <span class="link" @click="handleLink"> [{{ $t("自主提交") }}] </span>
        <br />
        {{ $t("感谢理解") }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions(["checkLogin"]),
    handleLink() {
      this.checkLogin()
        .then(() => {
          this.$router.push({
            path: "/report",
            query: {
              title: this.$t("reportIndex.更多问题"),
              formToken: 1,
              id: 1,
            },
          });
        })
        .catch(() => {
          this.$eventBus.$emit("showLogin");
        });
    },
  },
};
</script>
<style lang="less" scoped>
.queue-box {
  width: 100%;
  margin: 7.5px 0;
  .infos {
    margin-bottom: 8px;
    padding: 10px;
    border-radius: 15px;
    border-top-left-radius: 0 15px;
    background-color: #fff;
    .title {
      // margin-bottom: 2px;
      // padding-bottom: 9px;
      color: #333;
      font-size: 14px;
      line-height: 18px;
      // border-bottom: 1px solid rgba(0, 0, 0, 0.04);
      .link {
        color: @gold;
        font-weight: 500;
        // text-decoration: underline;
        cursor: pointer;
      }
    }
  }
}
</style>
